import styled from "styled-components";

import { colors, typography } from "src/assets/styles/settings";
import Modal from "src/components-v2/Modal";

export const ModalStyled = styled(Modal)`
  .c-modal__body {
    overflow-y: inherit !important;

    > div {
      padding: 0;
    }
  }
`;

export const ModalTitle = styled.p`
  color: ${colors.black_bekko};
  display: inline-block;
  font-size: ${typography.font_size.large};
  font-style: normal;
  font-weight: ${typography.font_weight.bold};
  line-height: ${typography.line_height};
  margin: 0;
`;

export const OTPWrapper = styled.div`
  .c-otp-input-box {
    border-radius: 8px;
    border: 1px solid ${colors.light_grey};
    height: 40px;
    width: 40px !important;
    margin-right: 14px;
    font-size: 21px;
    font-weight: 700;

    &:focus {
      background: ${colors.white};
      border-color: ${colors.tie_dye};
      box-shadow: 0 0 0 0.2rem ${colors.bubble};
      outline: 0;
    }

    &--disabled {
      background-color: ${colors.disabled};
      color: ${colors.dark_grey};
      cursor: not-allowed;
      opacity: 1;
    }

    &--error {
      border: 1px solid ${colors.ketchup_tomato};
    }
  }
`;
